import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { AxiosError } from 'axios';

import { SKU } from '../../../app/models/inventory';
import { axiosFetcher } from './common';

export function useSKUs(shouldFetch: boolean = true, config?: SWRConfiguration): SWRResponse<SKU[], AxiosError> {
  return useSWR<SKU[], AxiosError>(shouldFetch ? '/inventory/skus3' : null, axiosFetcher, config);
}
